import { createContext, useContext, useEffect, useState } from "react";
import {
  TypeContextDynamic,
  TypeContextDynamicProviderProps,
} from "./TypeContext";
import axios from "axios";
import { toast } from "react-toastify";
export type TypePartStateContext = {
  // createdAt: string;
  // updatedAt: string;
  _id: string;
  business: string;
  description: string;
  link?: string | undefined;
  urlImgCarre: string;
  classement: number;
  linkRedirectionCarre: string;
  urlImgRectangle?: string | undefined;
  linkRedirectionRectangle?: string | undefined;
};

const ContextDynamic = createContext<TypeContextDynamic | undefined>(undefined);

export const ContextDynamicProvider = ({
  children,
}: TypeContextDynamicProviderProps) => {
  const [filesUpload, setFilesUpload] = useState<File[] | null>(null);
  const [partenaires, setPartenaires] = useState<TypePartStateContext[]>([]);
  const [partenairesImage, setPartenairesImage] = useState<
    TypePartStateContext[]
  >([]);
  const [emoji, setEmoji] = useState<string>("");
  //to display pub business pro
  const [linkBusinessPro, setLinkBusinessPro] = useState("");
  const [linkBusinessImgPro, setLinkBusinessImgPro] = useState("");
  const [idBusinessPro, setIdBusinessPro] = useState("");
  //fecthdataPart
  const fecthDataPart = async () => {
    try {
      const res = await axios({
        method: "get",
        url: `${process.env.REACT_APP_API}partenaire/all`,
        withCredentials: true,
      });

      if (res.data) {
        const filtered = res.data.filter(
          (el: TypePartStateContext) => el.classement === 0
        );
        setPartenaires(filtered);

        //image
        const partenairesAutres = res.data.filter(
          (el: TypePartStateContext) => el.classement !== 0
        );
        setPartenairesImage(partenairesAutres);
      }
    } catch (error) {
      console.log(error);
      return toast.error("une erreur s'est produite");
    }
  };

  useEffect(() => {
    fecthDataPart();
  }, []);
  return (
    <ContextDynamic.Provider
      value={{
        filesUpload,
        setFilesUpload,
        partenaires,
        setPartenaires,
        partenairesImage,
        setEmoji,
        emoji,
        linkBusinessPro,
        setLinkBusinessPro,
        linkBusinessImgPro,
        setLinkBusinessImgPro,
        idBusinessPro,
        setIdBusinessPro,
      }}
    >
      {children}
    </ContextDynamic.Provider>
  );
};

export const Dynamic = () => {
  const context = useContext(ContextDynamic);
  if (!context) {
    throw new Error(
      "useContextDynamic must be used within a ContextDynamicProvider"
    );
  }

  return context;
};
